import { render, staticRenderFns } from "./o-hero-image.vue?vue&type=template&id=02032113&scoped=true"
import script from "./o-hero-image.vue?vue&type=script&lang=js"
export * from "./o-hero-image.vue?vue&type=script&lang=js"
import style0 from "./o-hero-image.vue?vue&type=style&index=0&id=02032113&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02032113",
  null
  
)

export default component.exports